import React from 'react';
import {IWayPointCreationSingleVoyage} from "@containers/singleVoyage/types/point";
import Stack from '@mui/material/Stack'
import {ITaskCreationSingleVoyageMutateVoyage} from "@containers/singleVoyage/mutateVoyage/tasks/types";
import PointTasksMiniInfoMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/pointsList/fullMode/pointItem/tasksMiniInfo/PointTasksMiniInfoMutateSingleVoyage";
import MutateTaskMutateSingleVoyageModal
    from "@containers/singleVoyage/mutateVoyage/tasks/MutateTaskMutateSingleVoyageModal";
import TasksListMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/tasks/tasksList/TasksListMutateSingleVoyage";
import {VoyageStatusSingleVoyage} from "@containers/singleVoyage/types/voyage";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";

interface IProps {
    point: IWayPointCreationSingleVoyage,
    numberStop?: number,
    tasks: ITaskCreationSingleVoyageMutateVoyage[]
    voyageStatus: VoyageStatusSingleVoyage
}

const TasksPointMutateSingleVoyage = ({
                                          point,
                                          numberStop,
                                          tasks,
                                          voyageStatus
                                      }: IProps) => {

    const {accountId, points} = useRootContextMutateSingleVoyage()

    // Labels come from every stop of the voyage: a task may cover more than this one.
    return (
        <Stack
            gap={'10px'}
        >
            {tasks?.length >= 1 && <PointTasksMiniInfoMutateSingleVoyage tasks={tasks}/>}

            <TasksListMutateSingleVoyage
                tasks={tasks}
                voyageStatus={voyageStatus}
                accountId={accountId}
                currentWaypointId={Number(point.id)}
            />

            <MutateTaskMutateSingleVoyageModal
                initial={{
                    waypointIds: [point.id]
                }}
                mode={'add'}
            />
        </Stack>
    );
};

export default TasksPointMutateSingleVoyage;
